import * as React from 'react';
import { Checkbox, Label, Spinner, SpinnerSize } from 'office-ui-fabric-react';

import './../../formelements.scss';
import EulaDialog from '../innleveringer/EulaDialog';
import {ToastContainer, toast, Slide} from "react-toastify";
import axios from 'axios';
import { ROOT_URL, SP_HOST_URL } from '../../actions/constants';

interface ICheckboxFieldPlagiatkontrollProps {
    input: any;
    label: string;
    required?: boolean;
    initialValue?: boolean;
    courseID?: string;
}

export interface ICheckboxFieldPlagiatkontrollState {
    showEulaDialog: boolean;
    eulaHtml: string;
    eulaModified: string;
    loading: boolean;
}
class CheckboxFieldPlagiatkontroll extends React.Component<
    ICheckboxFieldPlagiatkontrollProps,
    ICheckboxFieldPlagiatkontrollState
> {
    topRef = React.createRef<HTMLDivElement>();
    constructor(props) {
        super(props);
        this.state = {
            showEulaDialog: false,
            eulaHtml: '',
            eulaModified: '',
            loading: false,
        };
    }

    // Check if the user has accepted the latest EULA (End User License Agreement)
    // If not, show EULA dialog and wait for user to accept before sending submission
    // Backend will handle both the Turnitin and Ouriginal solutions
    checkEula = async () => {
        this.setState({ ...this.state, loading: true });
        const data: any = {};
        data.CourseID = this.props.courseID;

        try {
            const resp = await axios.post(`${ROOT_URL}/CheckEulaForCourse/${SP_HOST_URL}`, data, {
                headers: {
                    Authorization: localStorage.getItem('id_token')
                }
            })

            if (!!resp.data.eulaAcceptance) {
                this.props.input.onChange(true);
                this.setState({ ...this.state, loading: false });
            }
            else if (resp.data.errorInfo) {
                toast.error(`Det skjedde en feil ved sjekk av EULA-aksept med melding: ${resp.data.errorInfo?.LocalisedMessage}. Vennligst kontakt systemadministratoren.`, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    transition: Slide
                });
                this.setState({ ...this.state, loading: false });
            }
            else {
              this.setState({ 
                showEulaDialog: !resp.data.eulaAcceptance,
                eulaHtml: resp.data.eulaHtml,
                eulaModified: resp.data.eulaInfo ? resp.data.eulaInfo.valid_from : '',
                });
            }
        }
        catch (error) {
            console.error('Error checking EULA acceptance', error);
            toast.error('Det skjedde en feil ved sjekk av EULA-aksept. Vennligst kontakt systemadministratoren.', {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                transition: Slide
            });
            this.setState({ ...this.state, loading: false });
        }
      }
    
      acceptEula = () => {
        const data: any = {};
        data.CourseID = this.props.courseID;
        axios.post(`${ROOT_URL}/AcceptNewEulaForCourse/${SP_HOST_URL}`, data, {
            headers: {
                Authorization: localStorage.getItem('id_token')
            }
          }).then((resp) => {
            if (!!resp.data.eulaAcceptance) {
                this.props.input.onChange(true);
                this.setState({ ...this.state, showEulaDialog: false, loading: false });
            }
            else this.setState({ showEulaDialog: true, eulaHtml: resp.data.eulaHtml, eulaModified: resp.data.eulaInfo ? resp.data.eulaInfo.valid_from : '' });
          });
      }

    render() {
        return (
            <div className='ms-Grid-row'>
                <ToastContainer transition={Slide}/>
                <div className='z-form-group vertical-align checkbox-container'>
                    <div className='ms-Grid-col ms-sm12 ms-md4'>
                        <Label required={this.props.required} className='z-form-label'>
                            {this.props.label}
                        </Label>
                    </div>
                    {this.state.showEulaDialog && (
                        <EulaDialog
                            eulaHtml={this.state.eulaHtml}
                            lastModified={this.state.eulaModified}
                            onClose={(accept) => {
                                if (accept) this.acceptEula();
                                else {
                                    this.props.input.onChange(false);
                                    this.setState({ ...this.state, showEulaDialog: false, loading: false });
                                }
                            }}
                        />
                    )}
                    {this.state.loading ? (
                        <div className='ms-Grid-col ms-sm12 ms-md8 spinner' style={{ marginLeft: '12px' }}>
                            <Spinner size={SpinnerSize.small}/>
                        </div>
                    ) : (
                        <div className='ms-Grid-col ms-sm12 ms-md8 checkbox' style={{ marginLeft: '12px' }}>
                            <Checkbox
                                disabled={!this.props.courseID} // Disable checkbox if courseID is not provided to prevent crashing in the backend
                                checked={!!this.props.input.value}
                                onChange={async (e, checked) => {
                                    if (checked) await this.checkEula();
                                    else this.props.input.onChange(false);
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default CheckboxFieldPlagiatkontroll;
